import { useDebouncedValue } from "@/hooks/useDebouncedValue.jsx"
import { useWeatherDataRange } from "./useWeatherDataRange.jsx"

// Leere Steps nach einem Scene-Wechsel sind meist nur die nachladende Timeline
export const NOTICE_DELAY_MS = 1500

// reason: "error" | "none" | "before" | "after" | null
export function useWeatherAvailability({ controller, geoflowSession, timeOutOfRange }) {
  const [firstDataIso, lastDataIso] = useWeatherDataRange(controller.time.state.steps)

  const loading =
    geoflowSession.loading || controller.scenesLoading || controller.scenes.length === 0

  let reason = null
  if (!controller.weatherVisible) reason = null
  else if (geoflowSession.error || controller.scenesError) reason = "error"
  else if (loading) reason = null
  else if (!firstDataIso) reason = "none"
  else reason = timeOutOfRange ?? null

  const debouncedReason = useDebouncedValue(reason, NOTICE_DELAY_MS)
  // Nur das Einblenden verzögern, Ausblenden sofort
  const noticeReason = debouncedReason === reason ? reason : null

  return { reason, noticeReason, firstDataIso, lastDataIso }
}
